<div class="modal-header">
  <h5 class="modal-title">Module</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body">
    <form [formGroup]="moduleForm" (ngSubmit)="onFormSubmit()" id="ngForm">
        <div class="row">
            <div class="col-md-6">
                <label class="form-label">{{ 'name'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. Module" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['name'].errors?.['serverError']">
                    {{ fc['name'].errors?.['serverError'] }}
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ 'path'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. /security/dashboard" formControlName="path" [ngClass]="{'is-invalid': fc['path'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['path'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['path'].errors?.['serverError']">
                    {{ fc['path'].errors?.['serverError'] }}
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-md-6">
                <label class="form-label">{{ 'icon'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="text" placeholder="Ex. layout" formControlName="icon" [ngClass]="{'is-invalid': fc['icon'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['icon'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['icon'].errors?.['serverError']">
                    {{ fc['icon'].errors?.['serverError'] }}
                </div>
            </div>

            <div class="col-md-6">
                <label class="form-label">{{ 'position'|translate }} <span class="text-danger">*</span></label>
                <input class="form-control form-control-sm" type="number" placeholder="Ex. 10" formControlName="position" [ngClass]="{'is-invalid': fc['position'].invalid && isSubmitted}">
                <small class="invalid-feedback fst-italic" *ngIf="fc['position'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                <div class="invalid-feedback" *ngIf="fc['position'].errors?.['serverError']">
                    {{ fc['position'].errors?.['serverError'] }}
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-md-6">
                <label class="form-label">{{ 'layout'|translate }} <span class="text-danger">*</span></label>
                <ng-select
                        [items]="layouts"
                        bindLabel="name"
                        bindValue="name"
                        placeholder="{{ 'choose a layout'|translate }}"
                        formControlName="layout"
                        [ngClass]="{'is-invalid': fc['layout'].invalid && isSubmitted}"
                        [(ngModel)]="layoutSelected">
                </ng-select>
                <div class="invalid-feedback" *ngIf="fc['layout'].errors?.['required']">{{ 'this field is required'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['layout'].errors?.['serverError']">
                    {{ fc['layout'].errors?.['serverError'] }}
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ 'color'|translate }} <span class="text-danger">*</span></label>
                <ng-select
                        [items]="colors"
                        bindLabel="name"
                        bindValue="name"
                        placeholder="{{ 'choose a color'|translate }}"
                        formControlName="color"
                        [ngClass]="{'is-invalid': fc['color'].invalid && isSubmitted}"
                        [(ngModel)]="selectedColors">
                </ng-select>
                <div class="invalid-feedback" *ngIf="fc['color'].errors?.['required']">{{ 'this field is required'|translate }}</div>
                <div class="invalid-feedback" *ngIf="fc['color'].errors?.['serverError']">
                    {{ fc['color'].errors?.['serverError'] }}
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-md-6">
                <label class="form-label">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
                <div class="btn-radio" >
                    <div class="btn-group" data-bs-toggle="buttons">
                        <div class="btn btn-light txt-dark">
                            <div class="radio radio-dark">
                                <input id="radio21" formControlName="isEnable" type="radio" value='1'>
                                <label for="radio21">{{ 'yes'|translate }}</label>
                            </div>
                        </div>
                        <div class="btn btn-light txt-dark">
                            <div class="radio radio-dark">
                                <input id="radio22" formControlName="isEnable" type="radio" value='0'>
                                <label for="radio22">{{ 'no'|translate }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">{{ 'close'|translate }}</button>

    <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-outline-primary" [disabled]=saving>
        <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>
        <ng-template #isSaving>
            {{ "submitting" | translate }} ...
        </ng-template>
    </button>
</div>














